import { MODALITIES_REQUEST, MODALITIES_FETCH, MODALITIES_FAIL } from "../store/config";

const modalitiesInit = {
	isFetching:false,
	list:[],
	error:null,
	timestamp:null
};

const modalities = (state=modalitiesInit, actions) => {
	switch (actions.type){
		case MODALITIES_REQUEST:
			return {
				...state,
				isFetching: actions.isFetching,
				timestamp: actions.timestamp
			};
		case MODALITIES_FETCH:
			return {
				...state,
				isFetching: actions.isFetching,
				list: actions.payload,
				timestamp: actions.timestamp
			};
		case MODALITIES_FAIL:
			return {
				...state,
				isFetching: actions.isFetching,
				error: actions.error,
				timestamp: actions.timestamp
			};
		default:
			return {
				...state
			}
	}
};

export default modalities;


// WEBPACK FOOTER //
// ./src/reducers/modalities.jsx